import React, { Component } from "react";
import { translate as t } from "../../../../infrastructure/translate/localization";

import { getCsvEmployees } from "../../get-csv-employees";
import { displayInvalidCSVModal } from "../../displays/display-invalid-csv-modal";

import UploadCard from "./UploadCard";
import LoadingCard from "./LoadingCard";
import ButtonLink from "../../../../app/components/commons/buttonLink/ButtonLink";
import { redirect } from "../../../../app/routes/Routes";

export default class EditEmployeesCsvPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }

  async handleChangeFile(e) {
    const filename = e.target.files[0];
    this.setState({ isLoading: true });
    const csvProperties = await getCsvEmployees({
      type: "massiveEdit",
      filename,
    });
    if (csvProperties.isInvalid) {
      displayInvalidCSVModal(csvProperties.errorMessage);
      this.setState({ isLoading: false });
    }
  }

  render() {
    const { isLoading } = this.state;
    return (
      <main className="section">
        <div className="section-header with-link">
          <ButtonLink
            icon="arrow-left"
            textButton={t("employees-section.employees")}
            handlerClick={() => redirect("/v2/employees")}
          />
          <h1 className="section-title">
            {t("edit-employees.edit-employees")}
          </h1>
        </div>

        {isLoading ? (
          <LoadingCard />
        ) : (
          <UploadCard
            uploading={isLoading}
            uploadFile={(file) => this.handleChangeFile(file)}
          />
        )}
      </main>
    );
  }
}
